<div class="info-dialog flex flex-col">
    <h2 class="info-title">Message info</h2>
    <p class="info-preview" [innerHtml]="data.preview"></p>

    <div class="info-body simple-scroll" aria-live="polite">
        <p class="info-note" *ngIf="loading">Loading…</p>
        <p class="info-note" *ngIf="failed">Message info could not be loaded.</p>

        <ng-container *ngIf="!loading && !failed">
            <!-- ITP-E-249-05: a voice message's listeners, with when each first played it. -->
            <ng-container *ngTemplateOutlet="group; context: {title: 'Played by', icon: 'fa-solid fa-microphone played', rows: playedBy, at: 'playedAt'}"></ng-container>
            <ng-container *ngTemplateOutlet="group; context: {title: 'Read by', icon: 'fa-solid fa-check-double read', rows: readBy, at: 'readAt'}"></ng-container>
            <ng-container *ngTemplateOutlet="group; context: {title: 'Delivered to', icon: 'fa-solid fa-check-double', rows: deliveredTo, at: 'deliveredAt'}"></ng-container>
            <ng-container *ngTemplateOutlet="group; context: {title: 'Not delivered yet', icon: 'fa-solid fa-check', rows: waiting, at: null}"></ng-container>
            <p class="info-note" *ngIf="!playedBy.length && !readBy.length && !deliveredTo.length && !waiting.length">No one else is in this conversation.</p>
        </ng-container>
    </div>
</div>

<ng-template #group let-title="title" let-icon="icon" let-rows="rows" let-at="at">
    <section class="info-group" *ngIf="rows.length" [attr.aria-label]="title">
        <h3 class="info-group-title flex flex-row items-center">
            <i [ngClass]="icon" aria-hidden="true"></i>{{title}}
            <span class="info-group-count">{{rows.length}}</span>
        </h3>
        <ul class="info-list">
            <li class="info-row flex flex-row items-center" *ngFor="let receipt of rows; trackBy: trackByEmail">
                <span class="info-face" aria-hidden="true">{{initials(receipt)}}</span>
                <span class="info-name">{{receipt.name}}</span>
                <span class="info-time" *ngIf="at && receipt[at]">{{receipt[at] | date:'MMM d, h:mm a'}}</span>
            </li>
        </ul>
    </section>
</ng-template>

<mat-dialog-actions class="modal-footer flex flex-row justify-end items-center">
    <button mat-button class="orbitax-footer-button" (click)="onClose()" cdkFocusInitial>Close</button>
</mat-dialog-actions>
